import React from 'react'
import { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
// import Modal from './Modal'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import '../index.css'

import EnriqueBarba from '../assets/images/EnriqueBarba.jpg'

import konstantinos from '../assets/images/konstantinos-chonas-vastardos.jpg'
import menanyaMorris from '../assets/images/morris-menanya.jpg'
import genet from '../assets/images/genet-hagos.png'
import VladimirLubin from '../assets/images/vlad.png'
import serena from '../assets/images/serena-bohannon.jpg'
import shumet from '../assets/images/shumet-worku.png'
import victoria from '../assets/images/VICTORIA RUSCICA .jpg'
import ahmed_el_koly from '../assets/images/Ahmed-El-Kholy.png'
import hassan from '../assets/images/hassan.png'
import vivian from '../assets/images/vivian.png'
import LandingPageModal from './Modal'

const CarouselAboutUs = () => {
  const [isModalOpen, setIsModalOpen] = useState(false) // State to handle Modal visibility

  const handleModalClose = () => {
    setIsModalOpen(false)
  }

  const Workers = [
    {
      id: 2,
      title: 'Enrique Barba',
      role: 'Founder & CEO',
      description:
        'Enrique Barba has built and managed projects across business operations, consulting, and international ventures. His experience includes general management, shareholder coordination, and the design of operational and training systems for complex environments. In 2018, he entered the blockchain and cryptocurrency sector through trading and mining, later expanding into technical study of blockchain systems and decentralized technologies. Through this path, he identified the lack of structured, neutral, and personalized education in the space, leading to the creation of APOLO P2P as a one-to-one tutoring platform focused on technical blockchain learning.',
      imgSrc: EnriqueBarba,
    },
    {
      id: 10,
      title: 'Morris Menanya',
      role: 'Senior Frontend Engineer',
      description:
        'From building edtech platforms and fintech crypto wallets to mentoring aspiring developers and shipping production-ready full-stack products, Morris has spent the past several years writing clean, maintainable code and solving real-world problems. With a foundation in mechanical engineering and hands-on experience across multiple technologies and scalable architectures, he brings a thoughtful, engineering-first mindset to application development. Now a Frontend Developer at Apolo P2P, Morris focuses on delivering seamless user experiences, architecting robust systems, mentoring teams, and transforming complex technical challenges into intuitive, high-impact products.',
      imgSrc: menanyaMorris,
    },
    {
      id: 11,
      title: ' Genet Hagos ',
      role: 'Lead DevOps Engineer & System Architect',
      description:
        "Genet is a seasoned DevOps Engineer with 7 years of hands-on experience designing, automating, and optimizing cloud infrastructure and CI/CD pipelines. She specialize's in tools like Docker, Kubernetes, Terraform, and Ansible, and hold certifications in Azure and Kubernetes (CKA). Her expertise spans AWS, Azure, and on-premise environments, with a strong focus on scalability, security, and performance. She also enjoys solving complex challenges, collaborating with cross-functional teams, and driving operational efficiency through automation. She is passionate about emerging technologies like AI and their impact on engineering workflows. She thrive in fast-paced environments and is committed to continuous learning and innovation.",
      imgSrc: genet,
    },
    {
      id: 11,
      title: 'Ahmed El Kholy ',
      role: 'Lead Backend Engineer',
      description:
        'Ahmed Elkholy is a Software Engineer with over 10 years of experience in full software development lifecycle across banking, telecommunications, and enterprise environments. He currently works at Orange Business Services, specializing in Python, Django, React, and cloud-based solutions. Previously, he contributed to digital transformation initiatives at Microsoft and Qatar National Bank, focusing on automation, APIs, and data-driven systems. Ahmed has strong expertise in backend development, REST APIs, CI/CD pipelines, and process automation using Python and Azure services. He holds a Bachelor’s degree in Computer Science and multiple certifications in Azure, Python, and database technologies. let me know if you need to amend any',
      imgSrc: ahmed_el_koly,
    },
    {
      id: 9,
      title: 'Vladimir Lubin',
      role: 'Senior UX/UI designer',
      description:
        'Vladimir is a senior UX/UI designer with 15+ years of experience creating user-focused digital products for fintech, blockchain, ecommerce, and SaaS companies. He has led mobile app designs with over a million downloads, applying data-driven UX strategies to boost engagement and retention. Vladimir transforms complex requirements into intuitive, high-impact experiences, even for non-tech-savvy users in challenging emerging markets like Haiti. He has delivered projects across the U.S., Latin America, and the Caribbean.',
      imgSrc: VladimirLubin,
    },
    {
      id: 3,
      title: 'Konstantinos Chonas Vastardos',
      role: 'Backend Engineer',
      description:
        'Konstantinos Chonas Vastardos is a software engineer with a strong foundation in computer science and a growing track record of building practical, production-ready software. He enjoys working across the stack, focusing on writing clean, maintainable code and turning ideas into working products. Curious and driven by continuous improvement, he’s particularly interested in modern web technologies, scalable systems, and exploring how AI can be applied to solve real-world problems.',
      imgSrc: konstantinos,
    },

    {
      id: 12,
      title: 'Serena Bohannon',
      role: 'UX/UI designer',
      description:
        'Serena’s path into design comes from years of working closely with people and paying attention to what they need, often before they know how to ask for it. Nearly a decade in fast-paced, customer-facing roles sharpened their instincts for communication, adaptability, and problem-solving under pressure. A lifelong love of art influences how they translate complex ideas into intuitive visuals, while a personal interest in psychology and human behavior informs how they approach design.  Experiences in edtech sparked their fascination with learning systems and inclusive experiences. Today, Serena combines curiosity, creativity, and empathy to craft digital products that reduce friction and respond to real human needs.',
      imgSrc: serena,
    },
    {
      id: 8,
      title: 'Victoria Ruscica',
      role: 'Project Manager',
      description:
        "Victoria's career began with leading educational and scientific research projects before transitioning to delivering technology solutions in the private sector. After a decade of managing increasingly complex initiatives, she honed a talent for translating technical requirements into clear, actionable plans. Ongoing studies and certifications inform her methodical approach to business and data analysis, where diagnostics and automation are key. Her experience at major tech firms solidified the belief that technical rigor and respectful leadership are inseparable for ensuring success. As Project Manager of our international team, Victoria is focused on delivering state-of-the-art digital solutions and fostering a collaborative, growth-oriented environment.",
      imgSrc: victoria,
    },
    {
      id: 13,
      title: 'Shumet Worku',
      role: 'DevOps Engineer',
      description:
        'Shumet is a DevOps Engineer with extensive experience designing, automating, and maintaining scalable and secure infrastructure used in large, production-grade environments. He specializes in Kubernetes, Docker, CI/CD pipelines, and infrastructure automation using tools such as Terraform and Ansible, enabling reliable and efficient delivery of complex systems. At APOLO P2P, Shumet is responsible for building and maintaining cloud infrastructure, implementing CI/CD workflows, monitoring system performance, and enforcing security and reliability best practices. With a strong background in enterprise-scale systems, he focuses on stability, performance, and long-term scalability to support a global education platform.',
      imgSrc: shumet,
    },
    {
      id: 14,
      title: 'Hassan  Tariq',
      role: 'Lead Quantity Assurance',
      description:
        'Hassan Tariq is a Quality Assurance Engineer responsible for ensuring the reliability, performance, and overall quality of our platform. He specialises in identifying bugs, improving testing processes, and maintaining high standards across all releases. At APOLO P2P, Hassan works closely with developers and product teams to validate features, prevent regressions, and ensure a smooth user experience. With a strong attention to detail and a proactive approach, he plays a key role in delivering stable and user-focused products.',
      imgSrc: hassan,
    },
    {
      id: 4,
      title: 'Vivian Agenorwot ',
      role: 'customer support and operation',
      description:
        'Vivian Agenorwot is a customer support and operations leader with over 8 years of experience building and scaling high-performing service teams across global markets. She specialises in vendor management, performance optimisation, and designing systems that improve efficiency while maintaining a strong focus on customer experience. Vivian has led distributed global teams and managed outsourcing partners across multiple regions, driving measurable improvements in service quality, response times, and operational cost efficiency. Her approach combines data-driven decision-making with a strong people-first leadership style, ensuring both performance and team growth.',
      imgSrc: vivian,
    },
  ]

  return (
    <section className="CarouselAboutUs bg-white min-h-[700px]  pt-10 pb-20 flex items-center justify-center mb-0">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        slidesPerView={1}
        slidesPerGroup={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 14000, disableOnInteraction: false }}
        loop={true}
        centeredSlides={true} // ✅ Ensures each slide is centered
        className="CarouselAboutUs-Swiper "
      >
        <SwiperSlide>
          <div
            className={`w-full items gap-10 py-10 mb-14  px-8 !border-gray-300/30 rounded-xl md:w-[860px]  mt-0 mx-auto overflow- relative  text-center md:justify-center md:flex-row flex bg-[linear-gradient(#fff,#fff)_padding-box, linear-gradient(to_right,#f78430,#e12d2e,#cc154b) border_border-box]
     border shadow-[2px_2px_0px_4px_rgba(247,132,48,0.3)] md:shadow-[12px_12px_12px_4px_rgba(247,132,48,0.3)]  flex-col justify-start  font-inter font-normal text-[20px] leading-[28px] tracking-[0%]`}
          >
            <p className="text-sm">
              The crypto world is chaos, scammers shouting the loudest, misinformation running wild,
              and newcomers left wondering if they need a PhD just to keep up. At APOLO P2P, we had
              enough. So, we built a platform where real experts teach real knowledge, no gimmicks,
              no traps. <br />
              <br /> Founded by industry veterans who’ve seen it all, APOLO P2P helps learners cut
              through the nonsense and get straight to what matters. Our verified tutors,
              interactive learning tools, and seamless fiat/crypto payments make blockchain
              education accessible, engaging, and actually useful. No investment schemes, no paid
              hype, just clear, practical knowledge from people who know what they’re talking about.
              <br />
              <br />
              Whether you're understanding the basics of blockchain, navigating trading strategies,
              decoding white papers, tackling DeFi, mastering smart contracts, or just trying to
              make sense of gas fees, APOLO P2P is your shortcut to real understanding. No fluff. No
              scams. Just education that works.
            </p>
          </div>
        </SwiperSlide>

        {Workers.map((worker) => (
          <SwiperSlide key={worker.id} className=" p-2">
            <div
              className={`w-full items gap-10 py-10 mb-14   px-8 !border-gray-300/30 rounded-xl md:w-[860px]  mt-0 mx-auto overflow- relative  text-center md:justify-center md:flex-row flex bg-[linear-gradient(#fff,#fff)_padding-box, linear-gradient(to_right,#f78430,#e12d2e,#cc154b) border_border-box]
     border shadow-[2px_2px_0px_4px_rgba(247,132,48,0.3)] md:shadow-[12px_12px_12px_4px_rgba(247,132,48,0.3)]  flex-col justify-start `}
            >
              {worker.id !== 1 && (
                <img
                  src={worker.imgSrc}
                  alt={worker.title}
                  className="CarouselAboutUs-Image w-52 m-auto md:w-60 h-72 !rounded-2xl md:object-fill md:ml-2 md:mr-5 "
                />
              )}

              <div className="text-left">
                <h1 className="font-inter text-left font-extrabold text-[30px] leading-[28px] tracking-normal">
                  {worker.title}
                </h1>

                <h3 className=" text-2xl mt-3">{worker.role}</h3>
                <p
                  className={` text-sm h-60w  text-black font-normal text-left mt-3 -mb-3 ${worker.id === 1 ? 'mt-10' : ''}`}
                >
                  {worker.description.split('\n\n').map((para, index) => (
                    <p key={index} className="">
                      {para}
                    </p>
                  ))}
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      {isModalOpen && <LandingPageModal onClose={handleModalClose} />}
    </section>
  )
}

export default CarouselAboutUs
